module.exports = __webpack_public_path__ + "static/media/doubleShieldRoundPykes.41bdc941.jpg";